import { SVGProps } from 'react';
import { styled } from '@mui/material';
import classNames from 'classnames';

import LogoSvg from '@assets/images/AtsLogo.svg?react';

import { atsLogoClasses } from './utils';

type AtsLogoProps = SVGProps<SVGSVGElement> & {
  height?: number;
  width?: number;
};

const getsizeValue = (size: number | string | undefined = 'auto') => {
  if (typeof size === 'number') {
    if (size === 1) return '100%';
    return `${size}px`;
  }
  return size;
};

export const AtsLogo = styled(({ height, width, className, ...props }: AtsLogoProps) => (
  <LogoSvg className={classNames(atsLogoClasses.root, className)} {...props} />
))`
  fill: ${({ theme }) =>
    theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main};
  height: ${({ height }) => getsizeValue(height)};
  width: ${({ width }) => getsizeValue(width)};
`;
